import { ObjectSchema, object, string, number, mixed } from 'yup';
import { locale } from './../yup-locale';
import * as yup from 'yup';
import { Common, CommonLanguageType, MasterClockType, Status, commonLanguages } from './../../models/common';
yup.setLocale(locale);

export function commonValidator(): ObjectSchema<Common> {
    return object({
        id: string().uuid().strict(),
        vesselId: string().uuid().strict(),
        language: mixed<CommonLanguageType>().oneOf(Object.values(commonLanguages)).required().nonNullable().strict(),
        masterClockType: mixed<MasterClockType>()
            .oneOf(Object.values(MasterClockType))
            .required()
            .nonNullable()
            .strict(),
        UtcEnable: number<Status>().oneOf([0, 1]),
        japanCoastGuard: number<Status>().oneOf([0, 1]),
    })
        .strict()
        .noUnknown();
}
